import { render, staticRenderFns } from "./OrgItems1.vue?vue&type=template&id=dab41144&scoped=true&"
import script from "./OrgItems1.vue?vue&type=script&lang=js&"
export * from "./OrgItems1.vue?vue&type=script&lang=js&"
import style0 from "./OrgItems1.vue?vue&type=style&index=0&id=dab41144&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab41144",
  null
  
)

export default component.exports